import React, { useState } from 'react';
import { RmxServiceDetails } from '../RmxServiceActivityDetails/RmxServiceDetails';
import s from './SampleDetailModal.module.scss';
import { type ModalState } from '../../hooks/useModal';
import { type SampleData } from '../Service.types';
import { GenericModal } from '../../utils/GenericModal/GenericModal';
import { Tabs } from '../../utils/Tabs/Tabs';
import { RmxServiceSampleReview } from '../RmxServiceSampleReview/RmxServiceSampleReview';
import { SampleDetails } from '../RmxServiceActivityDetails/SampleDetails';
import { ShareModalProvider } from '../../hooks/ShareModalContext';
import { ActivityTable } from '../ActivityTable/ActivityTable';
import { QuoteTable } from '../QuoteTable/QuoteTable';
import { SamplesTable } from '../SamplesTable/SamplesTable';
import { PartsTable } from '../PartsTable/PartsTable';
import { nullIfUndefined } from '../../utils';
import clsx from 'clsx';
import { cast } from '../../../common/util';
import { SampleReportPdf } from '../SampleReport/SampleReport';

export type ModalTab = 'details' | 'review' | 'activity' | 'quotes' | 'samples' | 'parts' | 'report';

export type RmxServiceSampleModalParam = { resource: { sampleData: SampleData } };
type Props = {
  state: ModalState<RmxServiceSampleModalParam, undefined>;
  refetchSampleHistory: () => Promise<unknown>;
  reviewDisabled?: boolean;
};

export function RmxServiceSampleModal(props: Props) {
  const resource = props.state.param!.resource;
  const sampleData = resource.sampleData;
  const [activeTab, setActiveTab] = useState<ModalTab>('details');

  const isWideTab = cast<ModalTab[]>(['activity', 'quotes', 'samples', 'parts']).includes(activeTab);
  const dialogClassName = clsx(s['tab-modal-dialog'], {
    [s['wide-content']]: isWideTab
  });

  return (
    <GenericModal
      state={props.state}
      className={s['tab-modal']}
      dialogClassName={dialogClassName}
      contentClassName={s['tab-modal-content']}
      bodyClassName='d-flex flex-column align overflow-hidden p-0'
      label={'Sample'}
      showClose={true}
    >
      <ShareModalProvider state={props.state}>
        <Tabs
          setActiveTab={setActiveTab}
          withScroll={true}
          activeTab={activeTab}
          noMargin={true}
          growContent={true}
          tabs={[
            {
              key: 'details',
              title: 'Details',
              content: (
                <RmxServiceDetails>
                  <SampleDetails sample={sampleData} />
                </RmxServiceDetails>
              )
            },
            {
              key: 'report',
              title: 'Report',
              content: <SampleReportPdf sampleId={sampleData.sample.id} />
            },
            {
              key: 'review',
              title: 'Review',
              content: <RmxServiceSampleReview sample={sampleData.sample} disabled={props?.reviewDisabled} refetchSampleHistory={props.refetchSampleHistory} />
            },
            {
              key: 'activity',
              title: 'Activities',
              // serviceData.length === 0 ? <div className={s['no-data']}>{NoDataLabel}</div> :
              content: (
                <>
                  <ActivityTable filterByAssetId={sampleData.assetId} isMyWork={false} hideEllipsisButton={false} />
                </>
              )
            },
            {
              key: 'quotes',
              title: 'Quotes',
              content: <QuoteTable filterByAssetId={sampleData.assetId} />
            },
            {
              key: 'samples',
              title: 'Samples',
              content: <SamplesTable filterByAssetId={sampleData.assetId} filterOutReviewed={false} />
            },
            {
              key: 'parts',
              title: 'Parts',
              content: <PartsTable filterByAssetId={nullIfUndefined(sampleData.assetId)} filterBySiteId={null} />
            }
          ]}
        />
      </ShareModalProvider>
    </GenericModal>
  );
}
